import React from 'react';

import NavBarBottomUI from './NavBarBottom';

function NavBarBottom() {
    return <NavBarBottomUI
    />
}

export default NavBarBottom;